const shouldSkip = () => false;

export default shouldSkip;
